export default __webpack_public_path__ + "static/media/history-round-image.17b5c86c.png";